import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export type OAuthPlatform = "reddit" | "bluesky" | "youtube" | "twitter"

export const OAUTH_PLATFORMS = {
  reddit: "reddit" as const,
  bluesky: "bluesky" as const,
  youtube: "youtube" as const,
  twitter: "twitter" as const,
} as const

export function getPlatformDisplayName(platform: OAuthPlatform | string): string {
  switch (platform) {
    case "reddit":
      return "Reddit"
    case "bluesky":
      return "Bluesky"
    case "youtube":
      return "YouTube"
    case "twitter":
      return "X"
    default:
      return platform.charAt(0).toUpperCase() + platform.slice(1)
  }
}
